<template>
  <el-submenu
    v-if="naviData.children"
    :index="naviData.id + ''"
    :key="naviData.id"
  >
    <template v-slot:title>
      <!-- <i class="el-icon-menu colla"></i> -->
      <div class="navi-menu-item-container">
        <!-- 需要将不同的菜单设置为不同的图标。使用的为背景图。 -->

        <div
          class="icon"
          :style="{
            'background-image':
              'url(' +
              require(`../assets/images/light/${naviData.text}.png`) +
              ')',
          }"
          :class="{ colla: collapse }"
        ></div>
        {{ naviData.text }}
      </div>
    </template>
    <navi-menu-item-container
      v-for="(item, index) in naviData.children"
      :key="`navi-menu-item-container${index}`"
      :naviData="item"
    >
    </navi-menu-item-container>
  </el-submenu>
  <el-menu-item v-else :key="naviData.id" :index="itemFilter(naviData)">
    <i class="el-icon-menu" v-if="naviData.grade == '1'"></i>
    {{ naviData.text }}
  </el-menu-item>
</template>

<script>
import naviMenuItemContainer from "@/components/naviMenuItemContainer.vue";
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "naviMenuItemContainer",
  props: {
    naviData: {
      type: Object,
      default() {
        return {};
      },
    },
    collapse: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    naviMenuItemContainer,
  },
  setup(props, { emit }) {
    let methods = {
      itemFilter(value) {
        let { text, path } = value;
        let obj = {
          text,
          path,
          icon: "el-icon-s-management",
        };

        return JSON.stringify(obj);
      },
    };
    let computeds = {
      naviDataImg: computed(() => {
        if (props.naviData.children) {
          // url('../assets/images/light/报修.png')
          //  `url('../assets/images/light/'${props.naviData.text}'.png')`
          return `url(require(../assets/images/light/报修.png))`;
        }
      }),
    };
    return {
      ...methods,
      ...computeds,
    };
  },
});
</script>

<style lang="scss" scoped="scoped">
@import "~@/assets/styles/handle.scss";

.navi-menu-item-container {
  display: flex;
  width: fit-content;
  height: fit-content;
  align-items: center;
  align-content: center;

  .icon {
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    // @include background_image("naviMenuItemContainerIcon");
    // background-image:url('../assets/images/light/报修.png') ;
    // background-image:v-bind(naviDataImg) ;
    margin-right: 10px;

    &.colla {
      margin-right: 30px;
    }
  }
}
:deep(.el-menu-item) {
  background-color: red;
}
</style>
